import React from "react";

const DrySmall = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_458_1348)">
      <path
        d="M13.9047 7.2109C12.2143 4.89896 10.4465 3.24084 10.4465 3.24084C10.4465 3.24084 3.95755 9.62502 3.95755 14.4368C3.95755 18.7828 7.33361 21.3938 10.4465 21.3938C14.0307 21.3938 16.935 18.7823 16.935 14.4368C16.935 13.5347 16.7328 12.603 16.3998 11.6786"
        stroke="#FDFDFE"
        strokeWidth="0.8"
        strokeLinecap="round"
      />
      <path
        d="M15.7085 10.0989C15.4528 9.59754 15.1685 9.10518 14.8699 8.62924"
        stroke="#FDFDFE"
        strokeWidth="0.8"
        strokeLinecap="round"
      />
      <path
        d="M12.2564 15.1717C12.2564 15.1717 13.2046 12.6469 16.2397 11.7004C19.2754 10.7532 20.3189 8.13901 20.3189 8.13901"
        stroke="#FDFDFE"
        strokeWidth="0.8"
        strokeLinecap="round"
      />
      <path
        d="M9.81982 12.4874C9.81982 12.4874 10.768 9.96267 13.8031 9.01608C16.8388 8.0695 17.8822 5.45526 17.8822 5.45526"
        stroke="#FDFDFE"
        strokeWidth="0.8"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_458_1348">
        <rect
          width="18"
          height="20.1176"
          fill="white"
          transform="translate(3 2.11765)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default DrySmall;
